export default __webpack_public_path__ + "static/media/QR.730ed5c8.png";